export const initBeacon = () => {
  window.Beacon('init', process.env.REACT_APP_BEACON_ID);
};
